import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { skuBrandKeys } from "./query-keys";

/** GET /v1/sku/ap-names — distinct existing spellings for the Create SKU datalist (spec §3.4). */
export function useApNames() {
  return useQuery({
    queryKey: skuBrandKeys.apNames,
    queryFn: async (): Promise<string[]> => {
      const { data, error } = await apiClient.GET("/v1/sku/ap-names");
      if (error) throw error;
      return data.items;
    },
    staleTime: 5 * 60_000,
  });
}
